import {
  FILTER_CHANGE_ACTION,
  FILTER_FETCH_FAILED,
  FILTER_RECEIVE,
} from '../actions/filter';

export default (state, action) => {
  if (!state) {
    return {
      loading: false,
    };
  }

  switch (action.type) {
    case 'ROUTE_LOADED': {
      return {
        ...state,
        loading: false,
      };
    }

    case 'SORT_CHANGE': {
      return {
        ...state,
        loading: true,
      };
    }

    case FILTER_CHANGE_ACTION: {
      return {
        ...state,
        loading: true,
      };
    }

    case FILTER_FETCH_FAILED: {
      return {
        ...state,
        loading: false,
      };
    }

    case FILTER_RECEIVE: {
      return {
        ...state,
        loading: false,
      };
    }

    default:
  }

  return state;
};
